import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';
import { EIconButtons } from 'ui/EasTable/EasTableRow/EasTableValue/constants';
import { TSpecialTerritory } from 'redux/reducers/taxDuties/types';

const YES_NO_FILTER: [string | null | number, string][] = [
	['true', 'Yes'],
	['false', 'No'],
];

export const tableStructure: TTableStructure<keyof TSpecialTerritory>[] = [
	{
		name: 'ID',
		selector: 'id',
		show: false,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.LEFT,
		key: true,
	},
	{
		// The row carries the country as an id as well, but the code is what it shows.
		name: 'Country',
		selector: 'countryCode',
		show: true,
		sortable: true,
		filterable: false,
		searchable: false,
		colSpan: 1,
		type: ETableStructureType.COUNTRY_EU,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Country',
		selector: 'countryId',
		show: false,
		sortable: true,
		filterable: true,
		searchable: false,
		colSpan: 1,
		type: ETableStructureType.COUNTRY_EU,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Territory',
		selector: 'specialTerritoryName',
		show: true,
		sortable: true,
		filterable: false,
		searchable: true,
		colSpan: 2,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'VAT Rate',
		selector: 'vatRate',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		currency: () => '%',
	},
	{
		name: 'Supported',
		selector: 'isSupported',
		show: true,
		sortable: true,
		filterable: true,
		filter: YES_NO_FILTER,
		colSpan: 1,
		type: ETableStructureType.BOOLEAN,
		align: ETableStructureAlign.CENTER,
	},
	{
		name: 'Postal Codes',
		selector: 'postalCodes',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Comments',
		selector: 'comments',
		show: true,
		sortable: false,
		filterable: false,
		searchable: true,
		colSpan: 2,
		type: ETableStructureType.TEXT,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Actions',
		selector: 'actions',
		noName: true,
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.RIGHT,
		buttons: [
			{
				name: 'Postal Codes',
				icon: EIconButtons.EMAIL,
			},
			{
				name: 'Edit',
				icon: EIconButtons.EDIT,
			},
		],
	},
];
